import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { waUrl } from "../data";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "inicio", label: "Inicio" },
  { id: "nosotros", label: "Nosotros" },
  { id: "servicios", label: "Servicios" },
  { id: "galeria", label: "Galería" },
  { id: "testimonios", label: "Reseñas" },
  { id: "contacto", label: "Contacto" },
];

const scrollTo = scrollToId;

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkColor = scrolled ? "text-ink/70 hover:text-electric" : "text-white/80 hover:text-white";

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 2.4, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 ${scrolled ? "bg-white/85 backdrop-blur-xl border-b border-border/60" : "bg-transparent border-b border-transparent"}`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button onClick={() => scrollTo("inicio")} data-testid="nav-logo" aria-label="Ir al inicio">
          <Logo variant={scrolled ? "dark" : "light"} size={30} />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => scrollTo(l.id)} data-testid={`nav-${l.id}-link`} className={`text-sm font-semibold transition-colors duration-200 ${linkColor}`}>
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href={waUrl()} target="_blank" rel="noopener noreferrer" data-testid="nav-cta-button" className="inline-block bg-electric text-white text-sm font-semibold px-6 py-3 hover:bg-white hover:text-ink transition-colors duration-300">
            Pedir presupuesto
          </a>
        </div>

        <button className={`lg:hidden ${scrolled ? "text-ink" : "text-white"}`} onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menú">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="lg:hidden overflow-hidden bg-white border-b border-border">
            <div className="px-6 py-4 flex flex-col gap-1">
              {LINKS.map((l) => (
                <button key={l.id} onClick={() => { scrollTo(l.id); setOpen(false); }} data-testid={`mobile-nav-${l.id}-link`} className="text-left py-3 text-ink font-semibold border-b border-border/50 last:border-0">
                  {l.label}
                </button>
              ))}
              <a href={waUrl()} target="_blank" rel="noopener noreferrer" className="mt-3 bg-electric text-white text-center font-semibold py-3" data-testid="mobile-nav-cta">
                Pedir presupuesto por WhatsApp
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
